import React from 'react';
import { cn } from '@/lib/utils';

interface AvatarSkeletonProps {
  size?: number;
  className?: string;
  count?: number;
}

const AvatarSkeleton: React.FC<AvatarSkeletonProps> = ({
  size = 24,
  className,
  count = 3
}) => {
  return (
    <div className="flex -space-x-1.5 overflow-hidden">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "rounded-full bg-dark-300 animate-pulse",
            "border border-dark-400/50",
            className
          )}
          style={{ 
            width: size, 
            height: size,
            animationDelay: `${index * 150}ms`
          }}
        />
      ))}
    </div>
  );
};

export default AvatarSkeleton;